export default {
  field__account_number: 'Hesab nömrəsi (IBAN)',
  field__account_holder: 'Hesab sahibinin adı',
  field__bank_name: 'Bankın adı',
  field__bank_code: 'Bankın kodu',
  field__bank_ifsc_code: 'Bankın IFSC kodu',
  field__account_holder_address: 'Hesab sahibinin ünvanı',
  field__bank_address: 'Bankın ünvanı',
  field__bic: 'BIC',
  field__purpose_of_payment: 'Ödənişin təyinatı',
  field__pay_id: 'PayID',
  field__card_last_four_digits: 'Kartın son dörd rəqəmi',
  field__invoice_receipt_number: 'Faktura Qəbz nömrəsi',
};
